const topListings = [
  {
    listingUrl: '/trips/VYm1Aj2Y/',
    headline: 'top-listing--0--headline',
    location: 'top-listing--0--location',
    photoUrl: 'https://img.getmyboat.com/images/626ac0449c7f6/-processed.jpeg',
    rating: '5.0',
  },
  {
    listingUrl: '/trips/EYnooPwK/',
    headline: 'top-listing--1--headline',
    location: 'top-listing--1--location',
    photoUrl: 'https://img.getmyboat.com/images/c47b0c9b-8911-4b5e-bca6-56a99ed02e73/-processed.jpg',
    rating: '5.0',
  },
  {
    listingUrl: '/trips/EYnAXxja/',
    headline: 'top-listing--2--headline',
    location: 'top-listing--2--location',
    photoUrl: 'https://img.getmyboat.com/images/640a7ea7920fc/-processed.jpg',
    rating: '5.0',
  },
  {
    listingUrl: '/trips/QY6Q7ola/',
    headline: 'top-listing--3--headline',
    location: 'top-listing--3--location',
    photoUrl: 'https://img.getmyboat.com/images/fcad5ea7-bfa4-4eda-baf5-20b699dc1214/-processed.jpg',
    rating: '5.0',
  },
  {
    listingUrl: '/trips/MKyeJW2K/',
    headline: 'top-listing--4--headline',
    location: 'top-listing--4--location',
    photoUrl: 'https://img.getmyboat.com/images/6022f76bc95e7/-processed.jpg',
    rating: '5.0',
  },
  {
    listingUrl: '/trips/QY674nAK/',
    headline: 'top-listing--5--headline',
    location: 'top-listing--5--location',
    photoUrl: 'https://img.getmyboat.com/images/5f2c835b16317/boat-rentals-cabo-san-lucas-baja-california-sur-trimaran-processed.jpg',
    rating: '4.7',
  },
];

export default topListings;
